import { onSubmitAdmin } from 'utils';
import { AdminUpdateOnSubmitFunction } from './updateAdmin.type';

const adminUpdateOnSubmit: AdminUpdateOnSubmitFunction = payload => {
  return onSubmitAdmin({ method: 'put', ...payload, id: payload.admin.id });
};

export default adminUpdateOnSubmit;
